import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const Container = styled.div`
  ${({ shadowVisible }) =>
    shadowVisible &&
    css`
      &:before {
        content: "";
        position: sticky;
        top: -5px;
        margin-top: -5px;
        height: 5px;
        width: 100%;
        background-color: ${buildColor("white", "100")};
        z-index: 1000;
        box-shadow: 0 2px 5px ${buildColor("grey", "300")};
      }
    `}
`;

export default Container;
